export default "__VITE_ASSET__80a73ed2__"